<p-toast></p-toast>

<div class="profile-update-container">
  <p-dialog
    [(visible)]="displayDialog"
    [modal]="true"
    [style]="{width: '90vw', maxWidth: '460px'}"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [blockScroll]="true"
    styleClass="custom-profile-dialog"
  >
    <ng-container *ngIf="!isLoading else loadingTemplate">
      <div style="justify-items: self-start;" [ngClass]="{'dialog-custom-header': true, 'hidden-on-crop': isCropping,}">
        <img src="assets/imagem/Promptus_Logos-01.svg" alt="Promptus Logo" class="logo mb-3">
        <h2 class="dialog-title mb-1">Oi, que bom te ver por aqui!</h2>
        <p class="dialog-subtitle mb-4">Para aproveitar ao máximo a sua experiência, recomendamos que você atualize seu perfil.</p>
      </div>

      <div *ngIf="isCropping" class="cropping-section mb-4 text-center">
        <h3 class="mb-3">Recorte sua imagem</h3>
        <div class="cropper-image-container">
          <img #imageToCrop [src]="imagePreviewForCropper" alt="Imagem para recortar">
        </div>
        <div class="mt-3 crop-actions">
          <button pButton type="button" label="Confirmar Recorte" icon="pi pi-check" class="p-button-sm mr-2" (click)="recortarImagem()"></button>
          <button pButton type="button" label="Cancelar" icon="pi pi-times"
                  class="p-button-sm p-button-secondary p-button-outlined" (click)="cancelarRecorte()"></button>
        </div>
      </div>

      <div *ngIf="!isCropping" class="field flex flex-column align-items-center mb-4 profile-avatar-section">
        <div class="avatar-wrapper">
          <div class="avatar-display">
            <img *ngIf="imagePreview && imagePreview !== 'assets/imagem/placeholder-user.png'" [src]="imagePreview" alt="Avatar" class="profile-image-preview">
            <i *ngIf="!imagePreview || imagePreview === 'assets/imagem/placeholder-user.png'" class="pi pi-camera avatar-placeholder-icon"></i>
          </div>
          <button
            type="button"
            pButton
            icon="pi pi-pencil"
            class="edit-avatar-button"
            (click)="fileInput.click()"
            pTooltip="Alterar foto"
            tooltipPosition="top">
          </button>
          <input #fileInput type="file" accept="image/*" (change)="onFileSelectedFromInput($event)" style="display: none;">
        </div>
        <small *ngIf="fileError" class="p-error mt-1 text-center">{{ fileError }}</small>
      </div>

      <form [formGroup]="profileForm" (ngSubmit)="updateProfile()" *ngIf="!isCropping">
        <div class="p-fluid">
          <div class="field mb-3">
            <label for="apelido" class="block mb-1 form-label">Nome</label>
            <input pInputText id="apelido" formControlName="apelido" required
                   [ngClass]="{'ng-invalid ng-dirty': f?.['apelido']?.invalid && (f?.['apelido']?.dirty || f?.['apelido']?.touched)}"/>
            <small *ngIf="f?.['apelido']?.invalid && (f?.['apelido']?.dirty || f?.['apelido']?.touched) && f?.['apelido']?.errors?.['required']"
                   class="p-error block mt-1">Nome é obrigatório.</small>
          </div>

          <div class="field mb-4">
            <label for="email" class="block mb-1 form-label">Informe seu email</label>
            <input pInputText type="email" id="email" formControlName="email" required email
                   [ngClass]="{'ng-invalid ng-dirty': f?.['email']?.invalid && (f?.['email']?.dirty || f?.['email']?.touched)}"/>
            <small *ngIf="f?.['email']?.invalid && (f?.['email']?.dirty || f?.['email']?.touched)" class="p-error block mt-1">
              <span *ngIf="f?.['email']?.errors?.['required']">E-mail é obrigatório.</span>
              <span *ngIf="f?.['email']?.errors?.['email']">Formato de e-mail inválido.</span>
            </small>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-template #loadingTemplate>
      <div class="flex justify-content-center align-items-center" style="min-height: 300px;">
        <p-progressSpinner strokeWidth="4" animationDuration=".8s"></p-progressSpinner>
        <span class="ml-2">Atualizando...</span>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="dialog-custom-footer" style="margin-right: 57%;" *ngIf="!isCropping">
        <button pButton pRipple type="button" label="Salvar" class="p-button save-button"
                (click)="updateProfile()" [disabled]="isLoading || profileForm.invalid"></button>
        <button pButton pRipple type="button" label="Fazer isso depois" class="p-button-outlined skip-button"
                (click)="skipUpdate()" [disabled]="isLoading"></button>
      </div>
    </ng-template>
  </p-dialog>
</div>
